import React from 'react';
import clsx from 'clsx';

interface ClickableIconProps {
  icon: React.ReactNode;
  title?: string;
  disabled?: boolean;
  onClick: () => void;
}

const ClickableIcon: React.FC<ClickableIconProps> = ( { icon, title, disabled, onClick } ) => {
  return (
    <button
      className={ clsx(
        'relative group rounded-md p-2 trans-fast',
        disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:text-orange-600 cursor-pointer'
      ) }
      title={title}
      disabled={disabled}
      onClick={onClick}
    >
      {!disabled && (
        <span
          className="absolute inset-0 z-0 rounded-md bg-transparent group-hover:bg-orange-100 group-hover:shadow trans-fast scale-90 group-hover:scale-100"
          aria-hidden="true"
        />
      )}
      <span className="relative z-10">{icon}</span>
    </button>
  );
};

export { ClickableIcon };
